import { gql } from "@apollo/client"

const RANDOMIZER_JOB_STEP_FIELDS = gql`
  fragment RandomizerJobStepFields on RandomizerJobStep {
    id
    step
    number
    section
    name
    description
    responseType
    randomizerItemName
    responseMandatory
    response
    skip
    notApplicable
    unresolvedActions
    hasResolvedActions
    completed @client
    completedAt
    completedBy {
      ...JobStepCompletedByFields
    }
    uploads {
      ...JobStepUploadsFields
    }
    logic {
      range
      textValues
      outcomes {
        type
        steps
      }
    }
    notes {
      ...JobStepNotesFields
    }
    repeatable
  }
`

export { RANDOMIZER_JOB_STEP_FIELDS }
